import buttonStyle from '../../../materialUI/components/CustomButtons/buttonStyle'
import { whiteColor } from '../../../materialUI/jss/material-dashboard-pro-react'

const styles = {
  componentPanel: {
    marginTop: '50px',
    display: 'block',
  },
  fromToLabel: {
    textAlign: 'right',
    fontSize: 'var(--fs-13, 0.8125rem)',
    fontWeight: '600',
    marginTop: '20px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  formControl: {
    background: whiteColor,
  },
  inputField: {
    background: whiteColor,
  },
  layout: {
    alignItems: 'center',
    width: '70%',
    textAlign: 'left',
    height: '100%',
  },
  selectFix: {
    marginTop: '4px',
  },
  inputFix: {
    marginTop: '24px',
  },
  ctaSpacing: {
    marginTop: '24px',
    marginLeft: '28px',
  },
  ...buttonStyle,
}

export default styles
